// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseOutlinedSvg from "@fishx/icons-svg/es/asn/CloseOutlined";
import FishxIcon from '../components/FishxIcon';

var CloseOutlined = function CloseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseOutlinedSvg
  }));
};

CloseOutlined.displayName = 'CloseOutlined';
export default React.forwardRef(CloseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloseOutlined.js
// module id = 2240
// module chunks = 0